<template>
  <div id="app">
    <Header></Header>
    <div class="main-container" v-loading="loading">
      <Pre-page :nav="prePageNav"></Pre-page>
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <OneTitle :title="'搜索结果'"></OneTitle>
            <div class="search-result-list" v-if="cardList.length > 0">
              <div
                class="search-result-item"
                v-for="(item, i) in cardList"
                :key="'card' + i"
              >
                <SearchCard
                  :card="item"
                  @cardDetail="cardDetail"
                  :type="'researchCard'"
                ></SearchCard>
              </div>
              <div
                style="
                  margin: 40px 0 40px;
                  display: flex;
                  justify-content: center;
                "
              >
                <Pagination
                  :totalpage="totalpage"
                  @pageChange="pageChange"
                ></Pagination>
              </div>
            </div>
            <div class="search-result-none" v-else>
              标签搜索结果为空
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Pagination from "../components/pagination.vue";
import PrePage from "../components/PrePage.vue";
import OneTitle from "../components/OneTitle.vue";
import SearchCard from "../components/SearchCard.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Pagination,
    PrePage,
    OneTitle,
    SearchCard,
  },
  data: () => {
    return {
      totalpage: 10,
      currentpage: 1,
      loading: false,

      cardType: "0", //0 农技文章
      research: {
        createTime: "",
      },
      comments: [],
      prePageNav: [
        {
          name: "标签搜索",
          to: "",
        },
      ],
      cardList: [],
      id: "",
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);

    this.id = gus.id;
    this.loading = true;
    this.$axios
      .get(
        `websiteLabel/findWebsiteLabelResearch?websiteLabelId=${this.id}&pageSize=10&pageNum=1`
      )
      .then((res) => {
        console.log(res);
        this.loading = false;
        this.cardList = res.data.information.list;
        // this.totalpage = res.data.information.total;
      });
  },
  methods: {
    cardDetail(card) {
      if(!card.productId){
          location.href = `njzsxq.html?id=${card.researchId}&articleAreaId=${card.articleAreaId}`
      }else{
          location.href = `yyal.html?id=${card.researchId}`
      }
    },
    pageChange(n) {
      console.log(n);
      this.loading = true;
      this.$axios
        .get(
          `websiteLabel/findWebsiteLabelResearch?websiteLabelId=${this.id}&pageSize=10&pageNum=${n}`
        )
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.cardList = res.data.information.list;
          // this.totalpage = res.data.information.total;
        });
    },
  },
  filters: {
    nameNoPhone(nickName) {
      if (!nickName) {
        return nickName;
      } else {
        nickName = nickName.replace(/\d{11}/gi, "***");
        return nickName;
      }
    },
    upTo5(num) {
      num = parseInt((num - 0) * 5);
      if (num - 10000 > 0) {
        num = parseInt(num / 10000) + "w+";
      }
      return num;
    },
    timeAgo(time) {
      let between = Date.now() / 1000 - new Date(time).getTime() / 1000;
      if (between < 0) {
        between += 25200;
      }
      if (between < 3600) {
        return `${~~(between / 60)} 分钟前`;
      } else if (between < 86400) {
        return `${~~(between / 3600)} 小时前`;
      } else {
        return `${time.split(" ")[0]}`;
      }
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss">
.search-result-item {
  margin-bottom: 16px;
}
.search-result-none {
  text-align: center;
  font-size: 16px;
  color: #666;
  padding: 80px 0 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
video {
  width: 100%;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.research-links {
  margin: 40px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .research-link {
    width: 45%;
    text-align: left;
    vertical-align: bottom;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }
    a {
      color: #333;
      font-size: 16px;
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
    }

    .likeList {
      width: 360px;
    }
  }
}

.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 22px 0;
  img {
    max-width: 100%;
    display: block;
    width: 100%;
    height: auto !important;
  }
  video {
    max-width: 100%;
    width: 100%;
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
		padding-left: 10px;
	}
	.headers {
		width: 100%;
		padding-left: 10px;
	}
	#app {
		overflow: hidden;
	}
	#app .headers .header-nav {
		display: none;
	}

  .crop-selector-container .crop-selector{
    width: 100%;
  }
  .crop-selector-container .crop-selector .crop-item .crop-group{
    margin-right: 0;
    font-size: 14px;
  }
  .crop-selector-container .crop-selector .crop-item .crop-titles{
    font-size: 14px;
    line-height: 20px;
    a{
      min-width: 80px;
      margin-bottom: 6px;
    }
  }
  .crop-selector-container{
    padding: 20px 10px 14px;
  }
  .likeList{
    display: none;
  }
  .articleList-container .articleList-content{
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList{
      margin-right: 0;
    }
  }
}
</style>
